import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EnumLabelPipe } from '../../pipes/enum-label.pipe';
import { CommonComponentModule } from '../common/common.module';
import { CompleteTaskComponent } from './components/complete-task/complete-task.component';
import { LoaderComponent } from './components/loader/loader.component';
import { WorkListItemEntryComponent } from './components/work-list-item-entry/work-list-item-entry.component';
import { WorkListItemTaskCardComponent } from './components/work-list-item-task-card/work-list-item-task-card.component';
import { WorkListItemsComponent } from './components/work-list-items/work-list-items.component';
import { WorkListSummaryCardComponent } from './components/work-list-summary-card/work-list-summary-card.component';
import { WorkListTimerComponent } from './components/work-list-timer/work-list-timer.component';

@NgModule({
  declarations: [
    WorkListTimerComponent,
    CompleteTaskComponent,
    WorkListSummaryCardComponent,
    WorkListItemsComponent,
    WorkListItemEntryComponent,
    WorkListItemTaskCardComponent,
    LoaderComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    EnumLabelPipe,
    CommonComponentModule,
    MatTooltipModule,
  ],
  exports: [
    WorkListTimerComponent,
    CompleteTaskComponent,
    WorkListSummaryCardComponent,
    WorkListItemsComponent,
    WorkListItemEntryComponent,
    WorkListItemTaskCardComponent,
    LoaderComponent,
  ],
})
export class WorkListModule {}
